import styled from 'styled-components'

import Icon from '~/components/icon'
import { circleIcon, color } from '~/styles/utils'

import type { FixedGlyphIcon } from '~/components/icon'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;

  border-top: 1px solid #f1f1f1;
  padding: 20px 0;
`
export const AlertIcon: FixedGlyphIcon = styled(Icon).attrs({
  glyph: 'triangle-exclamation',
})`
  ${circleIcon({
    size: 30,
    bgColor: 'ikonGold',
  })};
  && {
    display: inline-flex;
    min-width: 30px;
    border: none;
    color: ${color('darkestGrey')};
    margin-right: 12px;
    flex-basis: 30px;

    &:before {
      margin-left: 1px;
      margin-top: -1px;
    }
  }
`
